import RoomType from '../roomType';
export default class Storage extends RoomType {
    constructor() {
        super();
        this.id = 'Storage';
        this.name = "Bod";
        this.icon = "mdi-package-variant";
        this.stateQuestions.questions = [
            {
                'id': 'floors',
                'title': 'Gulv og lister',
                'active': true,
                'value': -1
            },
            {
                'id': 'doors',
                'title': 'Dører',
                'active': true,
                'value': -1
            },
            {
                'id': 'walls',
                'title': 'Vegger',
                'active': true,
                'value': -1
            },
            {
                'id': 'windows',
                'title': 'Vindier og karmer',
                'active': true,
                'value': -1
            },
            {
                'id': 'ceiling',
                'title': 'Tak',
                'active': true,
                'value': -1
            },
            {
                'id': 'plugs',
                'title': 'Stikkontakter og lysbrytere',
                'active': true,
                'value': -1
            }
        ];
        this.cleanQuestions.questions = [
            {
                'id': 'door',
                'title': 'Dør',
                'active': true,
                'value': -1
            },
            {
                'id': 'floor',
                'title': 'Gulv',
                'active': true,
                'value': -1
            }
        ];

        this.contentTypes.options = [
            {
                'id': 'belysning',
                'title': 'Belysning',
                'active': false,
                'value': -1
            },
            {
                'id': 'shelfs',
                'title': 'Hyller',
                'active': false,
                'value': -1
            },
        ];
    }
}